import axios     from 'axios'
import Promotion from './endpoint/Promotion'

export const API = {
  Promotion: Promotion,
}

export const Http = {
  Endpoint: {
    Promotion: {
      Participate: {
        Path: 'siteParticipate',
        Type: 'post'
      },
      Config     : {
        Path: 'sitePromotionConfig',
        Type: 'post'
      },
    },
  },

  Client: axios.create({
    baseURL        : process.env.VUE_APP_API_URL || '',
    timeout        : process.env.VUE_APP_API_TIMEOUT || 7000,
    responseType   : 'json',
    crossDomain    : true,
    withCredentials: true,
    headers        : {
      'X-Requested-With': 'XMLHttpRequest',
      'X-AppVersion'    : process.env.VUE_APP_VERSION || ''
    }
  }),

  DoRequest: async (Endpoint, Data = {}) => {
    return await Endpoint.Type.toLowerCase() === 'get' ?
      Http.Client[Endpoint.Type](Endpoint.Path, { params: { ...Data } }) :
      Http.Client[Endpoint.Type](Endpoint.Path, Data, { params: {} })
  },

  All: axios.all,
}

Http.Client.interceptors.request.use((requestConfig) => {
  /*const token = null
  if (token) requestConfig.headers['Authorization'] = `Bearer ${token}`*/
  const lang = window.Vue ? window.Vue.$vuetify.lang.current : 'el-GR'
  if (!requestConfig.hasOwnProperty('params')) requestConfig.params = {}
  requestConfig.headers['Accept-Language'] = lang
  requestConfig.params = { ...requestConfig.params }
  return requestConfig
}, function (error) {
  return Promise.reject(error)
})

Http.Client.interceptors.response.use((response) => {
  return response
}, function (error) {
  return Promise.reject(error)
})
